import { CertificateOfStaff } from './certificate-of-staff.model';

export class Staff {
    id: number;
    staffCode: string;
    fullName: string;
    gender: number;
    dayOfBirth: Date;
    homeTown?: string;
    // dan toc
    folkId: number;
    folkName: string;
    // ton giao
    religionId: number;
    religionName: string;
    // Quoc tich
    nationalityId: number;
    nationalityName: number;
    // tieng dan toc
    LanguageFolk: string;
    // ngay chuyen den
    startWordDate?: Date;
    // Phong ban
    boardId: number;
    boardName: number;
    // trang thai CB
    personnelStatusId: number;
    ersonnelStatusName: string;
    // loai nhan su
    typeOfPersonnelId: number;
    typeOfPersonnelName: string;
    // chuc vu
    positionId: number;
    positionGVId: number;
    positionName: string;
    //Mon day
    subjectId?: number;
    subjectName?: string;
    //Mon day kiem nhiem
    subSubjectId?: number;
    subSubjectName?: string;
    // cap hoc
    schoolLevelId?: number;
    schoolLevelName?: string;
    // trinh do chuyen mon
    qualificationId?: number;
    qualificationName?: string;
    // chuyen nganh dao tao
    majorId?: number;
    majorName?: string;
    // Noi dao tao
    schoolName?: string;
    // ngach
    rankId?: number;
    rankName?: string;
    // bac
    degreeId?: number;
    degreeName?: string;
    // He so luong
    salaryRatio?: number;
    // so buoi day/ ngay
    numberOfSessionInDay?: number;
    // so tiet day/ tuan
    numberOfTeachInWeek?: number;
    // so tiet thuc KN/ tuan
    numberOfThucKN?: number;
    // thoi gian tham gia GDKT
    timeTeachingDisability?: string;
    // So cmnd
    idNumber?: string;
    // noi cap
    issuedBy?: string;
    // ngay cap
    idNumberDate?: Date;
    // sdt
    phoneNumber?: string;
    //email
    email?: string;
    // ho khau
    houseHold?: string;
    // noi o hien nay
    accommodation?: string;
    // tinh thanh
    provinceId?: number;
    provinceName?: string;
    // quan huyen
    districtId?: number;
    districtName?: string;
    //xa phuong
    wardId?: number;
    wardName?: string;
    // thon xom
    //villageId?: number;
    villageName?: string;
    // ten chung chi
    //degreeName?: string;
    // khoa dao tao
    courseName?: string;
    // thoi gian dao tao
    studyTime?: string;
    // ghi chu
    note?: string;
    // avata
    avartar: string;

    //listCertification
    listCertification: CertificateOfStaff[];

    // loai hop dong
    contractTypeId?: number;

    checked: boolean;
    constructor() {
        this.gender = 1;
    }
}

export class ShowImgUrlStaff {
  avatarUrl: string;
}
